import { actionGenerator, IReduxAction } from '../../utils/actions';
import { IPublishTermsState } from '../../types/reducers/publishTerms';
import { IAuction } from '../../types/reducers/auction';
import { ICalltrackingState } from '../../types/reducers/calltracking';
import { ITermsDuration } from '../../types/reducers/termsDurations';
import { IRecommendedPackage } from '../../types/reducers/recommendedPackages';
import { IPaidPublicationState, IPublicationPackagesState } from '../../reducers/v2';

export const LOAD_PUBLISH_TERMS_SUCCESS = 'PUBLISH_TERMS :: LOAD_SUCCESS';

export interface IPublishTermsSuccessPayload {
  publishTerms: IPublishTermsState;
  auction: IAuction;
  calltracking: ICalltrackingState;
  termsDurations: ITermsDurations;
  recommendedPackages: IRecommendedPackage[];
  dataV2: IDataV2;
}

interface IDataV2 {
  paidPublication: IPaidPublicationState;
  recommendedPackages: IRecommendedPackage[];
  publicationPackages: IPublicationPackagesState;
}

export interface ITermsDurations {
  durations: ITermsDuration[];
  durationInDays: number;
}

export type TLoadPublishTermsSuccessAction = IReduxAction<
  typeof LOAD_PUBLISH_TERMS_SUCCESS,
  IPublishTermsSuccessPayload
>;

export const loadPublishTermsSuccess = actionGenerator<typeof LOAD_PUBLISH_TERMS_SUCCESS, IPublishTermsSuccessPayload>(
  LOAD_PUBLISH_TERMS_SUCCESS,
);
